module.exports = __webpack_public_path__ + "static/media/play-bg.e273c9f4.png";